"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.button.title': 'Mostrar atajos de teclado',
};
